<div class="auth-page auth-page--welcome">
  <div class="auth-page__grid">
    <aside class="auth-showcase auth-showcase--brand" aria-hidden="true">
      <div class="auth-showcase__inner">
        <div class="auth-showcase__mockup">
          <div class="auth-showcase__mockup-bar">
            <span class="auth-showcase__mockup-dot"></span>
            <span class="auth-showcase__mockup-dot"></span>
            <span class="auth-showcase__mockup-dot"></span>
          </div>
          <div class="auth-showcase__mockup-body">
            <img
              src="/assets/images/logos/logo-icon.svg"
              class="auth-showcase__mockup-logo"
              alt=""
            />
            <span class="auth-showcase__mockup-chip">{{ 'auth.showcase.chip' | translate }}</span>
          </div>
        </div>

        <div class="auth-showcase__slides">
          <div class="auth-showcase__slide">
            <h2 class="auth-showcase__title">{{ 'auth.showcase.slide1Title' | translate }}</h2>
            <p class="auth-showcase__body">{{ 'auth.showcase.slide1Body' | translate }}</p>
          </div>
          <div class="auth-showcase__slide">
            <h2 class="auth-showcase__title">{{ 'auth.showcase.slide2Title' | translate }}</h2>
            <p class="auth-showcase__body">{{ 'auth.showcase.slide2Body' | translate }}</p>
          </div>
          <div class="auth-showcase__slide">
            <h2 class="auth-showcase__title">{{ 'auth.showcase.slide3Title' | translate }}</h2>
            <p class="auth-showcase__body">{{ 'auth.showcase.slide3Body' | translate }}</p>
          </div>
        </div>

        <div class="auth-showcase__dots" aria-hidden="true">
          <span class="auth-showcase__dot"></span>
          <span class="auth-showcase__dot"></span>
          <span class="auth-showcase__dot"></span>
        </div>
      </div>
    </aside>

    <main class="auth-main auth-main--welcome">
      <div class="auth-welcome__stage">
        <div class="auth-welcome__brand">
          <span class="auth-welcome__halo" aria-hidden="true"></span>
          <span class="auth-welcome__arc auth-welcome__arc--left" aria-hidden="true"></span>
          <span class="auth-welcome__arc auth-welcome__arc--right" aria-hidden="true"></span>
          <img
            src="/assets/images/logos/logo.svg"
            class="auth-welcome__logo"
            [attr.alt]="'auth.login.logoAlt' | translate"
          />
        </div>

        <div class="auth-welcome__panel">
          @if (sessionExpired) {
            <div class="auth-info-banner auth-info-banner--warn" role="status">
              <p class="auth-info-banner__text">{{ 'auth.welcome.sessionExpired' | translate }}</p>
            </div>
          }

          <h1 class="auth-welcome__headline">{{ 'auth.welcome.headline' | translate }}</h1>
          <p class="auth-welcome__tagline">{{ 'auth.welcome.tagline' | translate }}</p>

          <a class="auth-btn-primary auth-btn-primary--link" [routerLink]="['/authentication/login']">
            {{ 'auth.welcome.loginCta' | translate }}
          </a>

          <div class="auth-welcome__register">
            <span class="auth-welcome__register-hint">{{ 'auth.welcome.registerHint' | translate }}</span>
            <a class="auth-btn-secondary" [routerLink]="['/authentication/register']">
              {{ 'auth.welcome.registerCta' | translate }}
            </a>
          </div>
        </div>
      </div>
    </main>
  </div>
</div>
